export const templateStyle = {
	wrapper: {
		flex: '1',
		display: 'flex',
		flexDirection: 'column',
		// minHeight: '100vh',
	},

	content: {
		alignItems: 'stretch',
		display: 'flex',
		gap: '24px',
		maxWidth: '1200px',
		padding: '0 15px',
		width: '100%',
		margin: '0 auto',
		flex: 1,
		minHeight: 0,
		justifyContent: 'center',

		'@media (max-width: 1199.98px)': {
			padding: '0 40px',
		},

		'@media (max-width: 639.98px)': {
			padding: '0',
		},
	},

	main: {
		flex: '1',
		minWidth: 0,
		maxWidth: '870px',
		padding: '24px 0',
		display: 'flex',
		flexDirection: 'column',

		'@media (max-width: 1199.98px)': {
			maxWidth: 'none',
		},

		'@media (max-width: 639.98px)': {
			margin: '0',
		},
	},
};
